import { createBrowserHistory } from 'history'

let history = {
  push: link => {},
  replace: link => {},
  listen: link => {},
  location: {
    pathname: '/',
    search: '',
  },
}

try {
  history = createBrowserHistory()
} catch (error) {
  history = {
    push: path => {
      if (typeof window !== 'undefined') {
        window.location.pathname = path
      }
    },
  }
}

export default history
